import EditIcon from '@mui/icons-material/Edit';
import React, { useState, useEffect } from "react";
import axios from "axios";
import {uploads} from "../config";
import { API_URL } from "../config";

const ProfilePic = () => {
    const [show, setShow] = useState(false);
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [preview, setPreview] = useState("");
    //const [errors, setErrors] = useState({});
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("");
    const [data, setData] = useState([]);

    const uploadProfilePic = async () => {
        //if (!file) return alert("Please select a file first");
        if (!file) {
            setMessage("Please select a file first");
            setStatus("error");
            return;
        }

        const formData = new FormData();
        formData.append("business_logo", file); // match PHP key name

        try {
            setLoading(true);

            const res = await fetch(
                `${API_URL}/api-upload-update-profilepic.php`,
                {
                    method: "POST",
                    body: formData,
                    credentials: "include", // 🔥 REQUIRED
                }
            );

            const data = await res.json();

            if (data.status === "success") {
                //alert("Profile picture updated successfully");
                setMessage(data.message);
                setStatus("success");

                // if API returns new image path
                if (data.filepath) {
                    setPreview(data.filepath);
                }

                setShow(false);
                setFile(null);
            } else {
                //alert(data.message || "Upload failed");
                setMessage(data.message);
            }
        } catch (err) {
            console.error(err);
            alert("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    // ✅ GET USER PROFILE PICTURE
    useEffect(() => {
        axios
            .get(`${API_URL}/api-get-user-details.php`, {
                withCredentials: true,
            })
            .then((res) => {
                const user = res.data.data[0];
                setData(user);

                // ✅ Set image preview dynamically
                if (user.business_logo) {
                    setPreview(`${uploads}/${user.business_logo}`);
                }
            })
            .catch((err) => console.log(err));
    }, []);

    return (
        <div>
            <div className='imgbox profile-pic'>
                <img src={preview || "/images/default-profile-pic.jpg"} className="fullimg" alt={data.business_fullname}
                    onError={(e) => {
                        e.target.onerror = null; // prevent infinite loop
                        e.target.src = "/images/default-profile-pic.jpg";
                    }} />
                <div className="profile-pic-edit" onClick={() => setShow(!show)} ><EditIcon /></div>
            </div>
            {message && (<div style={{ color: status === "success" ? "#04af04" : "#f71717", margin: "0 0 10px 0", fontSize: "14px", fontWeight: "500" }}>{message}</div>)}
            <div className={`edit-profile-pic-form ${show ? "show" : "hide"}`}>
                <input type="file" className="filetextbox" accept="image/*" onChange={(e) => setFile(e.target.files[0])} />
                <button className="uploadbtn" onClick={uploadProfilePic} disabled={loading}>{loading ? "Uploading..." : "Update Image"} </button>
            </div>
        </div>
    );
};

export default ProfilePic; 